/**
  ---DO NOT EDIT THIS FILE DIRECTLY---
  This CSS file was concatenated from files listed in the css/ folder as part of a build process
  This is to allow for js import with @import links which will not be followed
**/

/* src/primitives/table/css/theme/table-theme.css */
@layer table.theme {
  :host {
  }
}

/* src/primitives/table/css/table-theme.css */

/* src/primitives/table/css/definition/table.css */
@layer table.definition {
  .table {
    display: table;
    width: 100%;
  }
}

/* src/primitives/table/css/table-definition.css */

/* src/primitives/table/css/table.css */
